import React from 'react';

import { Collapse } from 'antd';

const HistogramChart = (props) => {
    const { Panel } = Collapse;

    let statisticsData = props.getAnalysisRes.statistics;
    let statsRows = [];

    for (let i = 0; i < Object.keys(statisticsData).length; i++) {
        statsRows.push(Object.values(statisticsData)[i]);
    }

    // let newStatsRows = statsRows.map((item) => {
    //     let fixedValue = item.value;

    //     // if (typeof fixedValue === 'number') {
    //     //     fixedValue = fixedValue.toFixed(4);
    //     // }

    //     return (
    //         <Col
    //             span={{ xs: 12, sm: 8, md: 4, lg: 3 }}
    //             style={{ marginTop: 10 }}
    //             key={item.display_name}
    //         >
    //             <Card>
    //                 <Statistic
    //                     title={item.display_name}
    //                     value={fixedValue}
    //                     // precision={2}
    //                     // valueStyle={{ color: '#407CB1' }}

    //                     // prefix={<ArrowUpOutlined />}
    //                     // suffix="%"
    //                 />
    //             </Card>
    //         </Col>
    //     );
    // });

    // let statisticsTable = (
    //     <>
    //         <div key="12345" style={{ marginTop: '15px' }}>
    //             <Row
    //                 className="statistics-row-box"
    //                 gutter={16}
    //             >
    //                 {newStatsRows}
    //             </Row>
    //         </div>
    //     </>
    // );

    let newStatsRows2 = statsRows.map((item) => {
        let fixedValue = item.value;

        // if (typeof fixedValue === 'number') {
        //     fixedValue = fixedValue.toFixed(4);
        // }

        return (
            // <div
            //     key={item.value + item.display_name}
            //     className="box"
            // >
            <tr>
                <td className="title">{item.display_name}</td>
                <td className="value">{fixedValue}</td>
            </tr>
            // </div>
        );
    });

    let statisticsTable2 = (
        <>
            <div key="12345">
                {/* <Row className="statistics-row-box" gutter={16}> */}
                <div className="statistics-row-box">
                    <div className="table-box-fullproject-view">
                        {/* <h3>Statistics</h3> */}
                        <table className="table-table">
                            <tbody>{newStatsRows2}</tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

    let fullStats = (
        <div ref={props.forwardedRefStatistics}>{statisticsTable2}</div>
    );

    return (
        <>
            <Collapse bordered={false} defaultActiveKey={[1]}>
                <Panel key={1} header={`Statistics ${props.getAnalysisRes.filter_by_variable == null ? '': `[${props.getAnalysisRes.filter_by_variable}]`}`}>
                    {fullStats}
                </Panel>
            </Collapse>
        </>
    );
};

export default React.memo(HistogramChart);
